module.exports = __webpack_public_path__ + "static/media/ls-desktop-and-web-iconography.56bf6e3c.svg";